<template>
  <div class="editor-retention">
    <div class="ms-nodata ms-help" v-if="isNotAvailable">
      Для указания условий гарантийного удержания необходимо заполнить
      все атрибуты по каждому этапу календарного плана (номер, название, сроки и
      сумма)
    </div>
    <div v-else class="editor-retention__container">
      <wrapper
        :contract="contract"
        name="Гарантийное удержание"
        type="retention"
      />
    </div>
  </div>
</template>

<script>
import Wrapper from '../helpers/special-conditions/wrapper'
import { isRoadmapInvalid } from '@/utils'

export default {
  props: ['contract'],
  components: {
    Wrapper
  },
  computed: {
    isNotAvailable () {
      const { roadmaps } = this.contract

      if (!roadmaps || !roadmaps.length) return true
      if (roadmaps.filter((r) => !r.is_retention).some(isRoadmapInvalid)) {
        return true
      }

      return false
    }
  }
}
</script>

<style lang="less"></style>
